import { Pipe, PipeTransform } from '@angular/core';
import { ORDER_STATUSES_RELATED_NAMES, OrderStatus } from 'shared';

@Pipe({
  name: 'orderStatusPipe',
  standalone: true
})
export class OrderStatusPipe implements PipeTransform {
  transform(value: any): string {
    return ORDER_STATUSES_RELATED_NAMES[value as unknown as OrderStatus] || value;
  }
}
